// extracted by mini-css-extract-plugin
export default {"wrapper":"playLeaderboard_wrapper__ArdcF","tabs":"playLeaderboard_tabs__67Lg2","leaderboard":"playLeaderboard_leaderboard__0RHxG"};